import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import axios from "axios";
import HeaderComponent1styleA_studio from "./components/HeaderComponent1styleA_studio.js";
import HeaderComponent1styleA_shop from "./components/HeaderComponent1styleA_shop.js";
import FooterComponentStyleA_studio from "./components/FooterComponentStyleA_studio.js";
import FooterComponentStyleA_shop from "./components/FooterComponentStyleA_shop.js";

//user components:
import RoutesWithUserChatComponent from "./components/user/RoutesWithUserChatComponent";
import ScrollToTop from "./utils/ScrollToTop";

// publicly available pages
import HomeMenuPage from "./pages/HomeMenuPage";
import ServiziPage from "./pages/ServiziPage.js";
import ProdottiPage from "./pages/ProdottiPage.js";
import StaffPage from "./pages/StaffPage.js";
import AreaCompetenza from "./pages/AreaCompetenzaPage.js";
import ChiSiamoPage from "./pages/ChiSiamoPage.js";
import ContattiPage from "./pages/ContattiPage.js";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import ProductListPage from "./pages/ProductListPage";
import ServiceListPage from "./pages/ServiceListPage.js";
import ProductDetailsPage from "./pages/ProductDetailsPage";
import ServiceDetailsPage from "./pages/ServiceDetailsPage.js";
import CartPage from "./pages/CartPage";
import UserCartDetailsPage from "./pages/user/UserCartDetailsPage";
import BrandsPage from "./pages/BrandsPage"; 
import CouponsPage from "./pages/CouponsPage.js"; 
import Giftcards from "./pages/GiftcardsPage.js"; 
import UserOrdersPage from "./pages/user/UserOrdersPage.js";
import UserViewOrderPage from "./pages/user/UserOrderViewPage.js";

// protected admin pages
import AdminCategoriesPage from "./pages/admin/AdminCategoriesPage"; 
import AdminCreateCategoryPage from "./pages/admin/AdminCreateCategoryPage.js";
import AdminEditCategoryPage from "./pages/admin/AdminEditCategoryPage.js";

import AdminTypesPage from "./pages/admin/AdminTypesPage.js"; 
import AdminCreateTypePage from "./pages/admin/AdminCreateTypePage.js";
import AdminEditTypePage from "./pages/admin/AdminEditTypePage.js";

import AdminProductsPage from "./pages/admin/AdminProductsPage";
import AdminCreateProductPage from "./pages/admin/AdminCreateProductPage.js";
import AdminEditProductPage from "./pages/admin/AdminEditProductPage.js";
import AdminServicesPage from "./pages/admin/AdminServicesPage";
import AdminCreateServicePage from "./pages/admin/AdminCreateServicePage.js";
import AdminEditServicePage from "./pages/admin/AdminEditServicePage.js";

import AdminMessagesPage from "./pages/admin/AdminMessagesPage.js";
import AdminEditMessagePage from "./pages/admin/AdminEditMessagePage.js";
import AdminCustomersPage from "./pages/admin/AdminCustomersPage.js";
import AdminEditCustomerPage from "./pages/admin/AdminEditCustomerPage.js";
import AdminCreateCustomerPage from "./pages/admin/AdminCreateCustomerPage.js";
import AdminUsersPage from "./pages/admin/AdminUsersPage";
import AdminCreateUserPage from "./pages/admin/AdminCreateUserPage.js";
import AdminEditUserPage from "./pages/admin/AdminEditUserPage";
import AdminAnalyticsPage from "./pages/admin/AdminAnalyticsPage";
import AdminConfigsPage from "./pages/admin/AdminConfigsPage.js";
import AdminChatsPage from "./pages/admin/AdminChatsPage";
import AdminPaymentsPage from "./pages/admin/AdminPaymentsPage.js";
import AdminEditPaymentPage from "./pages/admin/AdminEditPaymentPage.js";
import AdminOrdersPage from "./pages/admin/AdminOrdersPage.js";
import AdminEditOrderPage from "./pages/admin/AdminEditOrderPage.js";

const config = require("./constants/constants.js")
const url = window.location.href;

// ------------ INI ----------- configurazione dal DB

const getConfigByProgressivoApiRequest = async (progressivoRagSoc) => {
  console.log("[getConfigByProgressivoApiRequest] leggo const con progressivo =", progressivoRagSoc);
  const url = `/api/configs/progressivo/` + progressivoRagSoc;
  const { data } = await axios.get(url);
  return data
}

function loadAppConfiguration() {
  getConfigByProgressivoApiRequest('0001').then((data) => {

    console.log(`data =`, data);  
    console.log(`[readAppConstants] applicativo =`, data?.applicativo);  
    console.log(`[readAppConstants] ragioneSociale =`, data?.ragioneSociale);  
    console.log(`[readAppConstants] cliente =`, data?.cliente);  

const configurazione = {
  applicativo           :data.applicativo,
  ragioneSociale: '',
  cliente: '',
  partitaIva: '',
  indirizzo: '',
  cap: '',
  citta: '',
  provincia: '',
  telefono: '',
  telefono1: '',
  telefono2: '',
  telefono3: '',
  mobile: '',
  mobile1: '',
  mobile2: '',
  mobile3: '',
  email: '',
  email1: '',
  email2: '',
  email3: '',
  imageLogo: '',
  aliquotaIva: '',
  aliquotaIvaRid: '',
  aliquotaIvaMin: '',
  aliquotaIva1: '',
  aliquotaIva2: '',
  aliquotaIva3: '',
  customerCode: '',
  titleProduct: '',
  siteStyleActive: '',
  enableSwitchStyle: '',
  urlSiteImageServer: '',
  urlCustomerImageServer: '',
};

/*
    configurazione.applicativo = data.applicativo;
    configurazione.ragioneSociale = data.ragioneSociale;
    configurazione.cliente = data.cliente;
    configurazione.partitaIva = data.partitaIva;
    configurazione.indirizzo = data.indirizzo;
    configurazione.cap = data.cap;
    configurazione.citta = data.citta;
    configurazione.provincia = data.provincia;
    configurazione.telefono = data.telefono;
    configurazione.telefono1 = data.telefono1;
    configurazione.telefono2 = data.telefono2;
    configurazione.telefono3 = data.telefono3;
    configurazione.mobile = data.mobile;
    configurazione.mobile1 = data.mobile1;
    configurazione.mobile2 = data.mobile2;
    configurazione.mobile3 = data.mobile3;
    configurazione.email = data.email;
    configurazione.email1 = data.email1;
    configurazione.email2 = data.email2;
    configurazione.email3 = data.email3;
    configurazione.imageLogo = data.imageLogo;
    configurazione.aliquotaIva = data.aliquotaIva;
    configurazione.aliquotaIvaRid = data.aliquotaIvaRid;
    configurazione.aliquotaIvaMin = data.aliquotaIvaMin;
    configurazione.aliquotaIva1 = data.aliquotaIva1;
    configurazione.aliquotaIva2 = data.aliquotaIva2;
    configurazione.aliquotaIva3 = data.aliquotaIva3;
    configurazione.customerCode = data.customerCode;
    configurazione.titleProduct = data.titleProduct;
    configurazione.siteStyleActive = data.siteStyleActive;
    configurazione.enableSwitchStyle = data.enableSwitchStyle;
    configurazione.urlSiteImageServer = data.urlSiteImageServer;
    configurazione.urlCustomerImageServer = data.urlCustomerImageServer;
*/
    return configurazione;
  })
    .catch((er) => {
      console.log(er);
    });
}

/*
loadAppConfiguration();
console.log('[App] configurazione =',configurazione); 
console.log('[App] configurazione.applicazione =',configurazione.applicazione); 
*/

// ------------ FIN ----------- configurazione dal DB

// thema da configurazione
let site_style_active = config.SITE_STYLE_ACTIVE;
// esecuzione locale
if (url.includes("http://localhost:3000")) site_style_active = "B";
// esecuzione prod
if (url.includes("mystudionline.it")) site_style_active = "B";
// esecuzione prod subdomains
if (url.includes("classic.mystudionline")) site_style_active = "A";
if (url.includes("modern.mystudionline")) site_style_active = "B";
if (url.includes("jazz.mystudionline")) site_style_active = "C";
if (url.includes("time.mystudionline")) site_style_active = "D";

console.log(url);
console.log('This will fire1!');
console.log(site_style_active);

if (url.includes("http://localhost:3000")) site_style_active = "B";   // 1m blu chiaro+ 1m grigio chiaro = DEFAULT
if (url.includes("http://localhost:3000")) site_style_active = "C";   // 1m grigio chiaro + 1m bianco
if (url.includes("http://localhost:3000")) site_style_active = "D";   // 1m blu scuro + 1m blu scuro

if (url.includes("http://localhost:3000")) site_style_active = "B";   // 1m blu chiaro + 2m grigio, footer grigio  (last version)
if (url.includes("http://localhost:3000")) site_style_active = "A";   // menu 1 minuscolo in blu fb, footer grigio (last version)

site_style_active = "A";

function App() {

  const [configApp, setConfigApp] = useState({});
  const [applicativo, setApplicativo] = useState("");
  const [siteStyle, setSiteStyle] = useState("");
  
  const site_style_active = "A";

  useEffect(() => {
    /* 
    -----------------------------------------------------------------
            SETUP da collection CONFIGS
    -----------------------------------------------------------------

      applicativo = 'myshop','mystudio','myplanner'       // da questo cambiano menuMain e menuAdmin

      siteStyle   = 'classic','modern','jazz','time'      // da questo cambiano i colori del menuMain 

    -----------------------------------------------------------------
    */
    getConfigByProgressivoApiRequest('0001').
      then((data) => {
        setApplicativo(data?.applicativo);
        setSiteStyle(data?.siteStyle);
        console.log(`[readAppConstants] data =`, data);  
      })
      .catch((er) => {
        console.log(er);
      });
  }, [setApplicativo]);


  return (

    <BrowserRouter>
    
      <ScrollToTop />

      { applicativo === 'mystudio' && siteStyle === "classic" &&
          <HeaderComponent1styleA_studio />
      }
      { applicativo === 'myshop' && siteStyle === "classic" &&
          <HeaderComponent1styleA_shop />
      }
      {/* 
      */}

      {/* 
      {site_style_active === 'A' && <HeaderComponent1styleA_shop />}
      */}

      <Routes>
        <Route element={<RoutesWithUserChatComponent />}>

          <Route path="/" element={<HomeMenuPage />} />
          <Route path="/servizi" element={<ServiziPage />} />
          <Route path="/prodotti" element={<ProdottiPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/registra" element={<RegisterPage />} />
          <Route path="/staff" element={<StaffPage />} />       
          <Route path="/area-competenza" element={<AreaCompetenza />} />       
          <Route path="/chi-siamo" element={<ChiSiamoPage />} />       
          <Route path="/contatti" element={<ContattiPage />} />       
          <Route path="/brands" element={<BrandsPage />} />
          <Route path="/coupons" element={<CouponsPage />} />
          <Route path="/giftcards" element={<Giftcards />} />

          <Route path="/product-list/category/:categoryName" element={<ProductListPage />} />
          <Route path="/product-details/:id" element={<ProductDetailsPage />} />
          <Route path="/service-list/type/:categoryName" element={<ServiceListPage />} />
          <Route path="/service-details/:id" element={<ServiceDetailsPage />} />

          <Route path="/cart" element={<CartPage />} />
          <Route path="/user/cart-details" element={<UserCartDetailsPage />} />

          <Route path="/orders/user/:id" element={<UserOrdersPage />} />
          <Route path="/orders/user/view/:id/:user" element={<UserViewOrderPage />} />

        </Route>

        <Route element={<RoutesWithUserChatComponent />}>

          <Route path="/admin/categories" element={<AdminCategoriesPage />} />
          <Route path="/admin/create-new-category" element={<AdminCreateCategoryPage />} />
          <Route path="/admin/edit-category/:id" element={<AdminEditCategoryPage />} />

          <Route path="/admin/types" element={<AdminTypesPage />} />
          <Route path="/admin/create-new-type" element={<AdminCreateTypePage />} />
          <Route path="/admin/edit-type/:id" element={<AdminEditTypePage />} />

          <Route path="/admin/products" element={<AdminProductsPage />} />
          <Route path="/admin/create-new-product" element={<AdminCreateProductPage />} />
          <Route path="/admin/edit-product/:id" element={<AdminEditProductPage />} />
          <Route path="/admin/services" element={<AdminServicesPage />} />
          <Route path="/admin/create-new-service" element={<AdminCreateServicePage />} />
          <Route path="/admin/edit-service/:id" element={<AdminEditServicePage />} />

          <Route path="/admin/messages" element={<AdminMessagesPage />} />
          <Route path="/admin/edit-message/:id" element={<AdminEditMessagePage />} />

          <Route path="/admin/customers" element={<AdminCustomersPage />} />
          <Route path="/admin/create-new-customer" element={<AdminCreateCustomerPage />} />
          <Route path="/admin/edit-customer/:id" element={<AdminEditCustomerPage />} />

          <Route path="/admin/users" element={<AdminUsersPage />} />
          <Route path="/admin/create-new-user" element={<AdminCreateUserPage />} />
          <Route path="/admin/edit-user/:id" element={<AdminEditUserPage />} />

          <Route path="/admin/analytics" element={<AdminAnalyticsPage />} />
          <Route path="/admin/configs" element={<AdminConfigsPage />} />

          <Route path="/admin/chats" element={<AdminChatsPage />} />

          <Route path="/admin/payments" element={<AdminPaymentsPage />} />
          <Route path="/admin/edit-payment/:id" element={<AdminEditPaymentPage />} />

          <Route path="/admin/orders" element={<AdminOrdersPage />} />
          <Route path="/admin/edit-order/:id" element={<AdminEditOrderPage />} />

        </Route>

      </Routes>

      { applicativo === 'mystudio' && siteStyle === "classic" &&
          <FooterComponentStyleA_studio />
      }
      { applicativo === 'myshop' && siteStyle === "classic" &&
          <FooterComponentStyleA_shop />
      }


      {/* 
      {site_style_active === 'A' && <FooterComponentStyleA />}
      */}

    </BrowserRouter>


  );
}

export default App;      